import React from "react";
import BranchesReportStyle from "./style";
import DevelopmentImg from "../../../../assets/Icons/development-img.png"
import { Row } from "antd";

const BranchesReport = () => {

    const CourserOverviewData = [
        {
            label: "Completion rate",
            value: "0.0%"
        },
        {
            label: "Completed courses",
            value: 0
        },
        {
            label: "Courses in progress",
            value: 0
        },
        {
            label: "Courses not passed",
            value: 0
        },
        {
            label: "Courses not started",
            value: 0
        },
        {
            label: "Training time",
            value: "0h 0m"
        },
    ]

    return(
        <>
            <BranchesReportStyle>
                <div className="user-title-container users-menu-filter-container">
                    <h1 className="user-menu-title">Branch Reports</h1>
                </div>

                <div className="course-overview-data-box">
                    {CourserOverviewData.map((item, index) => {
                        return(
                        <div key={index}>
                            <p className="overview-value">{item.value}</p>
                            <p className="overview-label">{item.label}</p>
                        </div>
                        )
                    })}
                </div>

                <Row className="yet-designed-pages">
                    <img src={DevelopmentImg} alt={DevelopmentImg} className="yet-designed-pages-image"/>
                    <div className="yet-designed-pages">
                        <p className="developement-content">There are no branches yet!</p>
                    </div>
                </Row>
            </BranchesReportStyle>
        </>
    )
}

export default BranchesReport;